import styled from '@emotion/styled';

export const CheckboxWrapper = styled.label`
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #555555;
  &:hover {
    & input:not(:checked) {
      & ~ span {
        border: 1px solid #7fe200;
      }
    }
    & input:is(:checked) {
      & ~ span {
        border: 1px solid #7fe200;
        background-color: #7fe200;
      }
    }
  }
  input {
    display: none;

    &:disabled + span {
      cursor: default;
      border-color: #999;
      background: #c4c4c4;
    }
    &:disabled + span + div {
      cursor: default;
    }

    &:checked {
      & ~ span {
        border: 1px solid #00bf00;
        background-color: #00bf00;

        &:after {
          display: block;
        }
      }

      &:disabled ~ span {
        border-color: #bdbdbd;
        background-color: #c4c4c4;
      }
    }
  }
`;

export const CheckboxSquare = styled.span`
  display: block;
  position: relative;
  width: 14px;
  height: 14px;
  cursor: pointer;
  margin: auto 10px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background: unset;
  border: 1px solid #555555;
  border-radius: 4px;
  box-sizing: border-box;

  &:after {
    content: '';
    position: absolute;
    display: none;
    left: 1px;
    top: 1px;
    width: 8px;
    height: 4px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotate(-45deg);
  }
`;

export const InnerLabel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
